export enum AlertType {
  None = "none",
  Warning = "warning",
  Error = "error"
}

export enum AlertClosingType {
  LeftButton = "left",
  RightButton = "right",
  OuterLeftButton = "outerleft",
  CloseButton = "close"
}

export enum PrimaryButton {
  LeftButton = "left",
  RightButton = "right",
  OuterLeftButton = "outerleft"
}
export interface AlertBoxOptions {
  type: AlertType;
  title: string;
  description: string;
  leftButtonTitle: string;
  rightButtonTitle?: string;
  primaryButton?: PrimaryButton;
  outerLeftButtonTitle?: string;
  outerLeftButtonDisabled?: boolean;
  leftButtonDisabled?: boolean;
  rightButtonDisabled?: boolean;
}
